import { call, put, takeLatest, fork, all, delay, } from 'redux-saga/effects';
import {
    CUSTOM_PRICE_LIST_ACTION, CUSTOM_PRICE_LIST_FAIL,
    CUSTOM_PRICE_DETAIL_FAIL, CUSTOM_PRICE_DETAIL_ACTION,
    CUSTOM_PRICE_DETAIL_UPDATE_ACTION, CUSTOM_PRICE_DETAIL_CREATE_ACTION
} from '../constants/Types';
import * as CustomPriceService from './../services/customPriceService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import { notification } from 'antd'
import { omit } from 'lodash';
import {
    setListPrices as setListCustomPriceAction,
    setCustomPriceDetail as setCustomPriceDetailAction,
} from './../actions/customPriceAction';
import {SAGA_DELAY_TIMEOUT} from '../constants/Define';

function* setListCustomPriceSaga() {
    yield takeLatest(CUSTOM_PRICE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const limit = action.filters.pageSize ? action.filters.pageSize : undefined;
        const offset = action.filters.pageIndex ? (action.filters.pageIndex - 1) * limit : undefined;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            limit, offset,
        }
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(CustomPriceService.getCustomPrices, params);
        yield put(setListCustomPriceAction(result));
    }, handleCustomPriceError(CUSTOM_PRICE_LIST_FAIL)))
}

function* setCustomPriceDetailSaga() {
    yield takeLatest(CUSTOM_PRICE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CustomPriceService.getCustomPriceDetail, action.id);
        yield put(setCustomPriceDetailAction(result));
    }, handleCustomPriceError(CUSTOM_PRICE_DETAIL_FAIL)))
}

function* updateCustomPriceSaga() {
    yield takeLatest(CUSTOM_PRICE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CustomPriceService.updateCustomPrice, action.price);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.price.title')} "${action.price.name}"` })
        yield put(setCustomPriceDetailAction(action.price));
    }, handleCustomPriceError(CUSTOM_PRICE_DETAIL_FAIL)))
}

function* createCustomPriceSaga() {
    yield takeLatest(CUSTOM_PRICE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(CustomPriceService.createCustomPrice, action.price);
        Func.sagaSuccessMessage({ action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.price.title')} "${action.price.name}"` })
        yield put(setCustomPriceDetailAction(action.price));
    }, handleCustomPriceError(CUSTOM_PRICE_DETAIL_FAIL)))
}

function handleCustomPriceError(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'price');
}


export function* customPriceSaga() {
    yield all([
        fork(setListCustomPriceSaga),
        fork(setCustomPriceDetailSaga),
        fork(updateCustomPriceSaga),
        fork(createCustomPriceSaga),
    ])
}
